import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export type CallrDocumentType = 'COMPANY_REG' | 'POA' | 'MANDATE' | 'ID' | 'OTHER';

export interface CallerIdPreviewFile {
  id: string;
  name: string;
  mime_type: string;
  send: boolean;
  type: CallrDocumentType | null;
  reason: string;
  description: string;
  person_names: string[];
  company_names: string[];
  phone_numbers: string[];
}

export interface CallerIdPreview {
  name: string;
  phone: string | null;
  note: string;
  existingCallerId: { state: string; third_party: string } | null;
  blockers: string[];
  files: CallerIdPreviewFile[];
}

/**
 * Reads the user's files (AI) and tells what a caller ID request would send to Callr. Writes nothing.
 */
async function previewUserCallerId(userUid: string, auth: Authentication | null): Promise<CallerIdPreview> {
  try {
    if (!auth) throw new PreviewUserCallerIdFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(`/backoffice/users/${userUid}/callerid/preview`, {}, auth.token);

    return response.data;
  } catch (e) {
    if (e instanceof PreviewUserCallerIdFailure) throw e;
    const errMessage = e instanceof Error ? e.message : typeof e === 'string' ? e : '';
    throw new PreviewUserCallerIdFailure(
      errMessage.trim() || 'Analyse des documents indisponible. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class PreviewUserCallerIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default previewUserCallerId;
